import React from "react";
import ReactDOM from "react-dom";
import styles from "./index.module.scss";
export default class RenderTooltip extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tooltipPosition: "top",
        };
    }
    componentDidMount() {
        this.adjustTooltipPosition();
    }
    getTooltipStyles() {
        switch (this.state.tooltipPosition) {
            case "top":
                return {
                    bottom: "100%",
                    left: "50%",
                    transform: "translateX(-50%)",
                    marginBottom: "6px",
                };
            case "right":
                return {
                    left: "100%",
                    top: "50%",
                    transform: "translateY(-50%)",
                    marginLeft: "6px",
                };
            case "bottom":
                return {
                    top: "100%",
                    left: "50%",
                    transform: "translateX(-50%)",
                    marginTop: "6px",
                };
            case "left":
                return {
                    right: "100%",
                    top: "50%",
                    transform: "translateY(-50%)",
                    marginRight: "6px",
                };
            default:
                return {};
        }
    }
    getTooltipPositionClass() {
        switch (this.state.tooltipPosition) {
            case "top":
                return styles.tooltipTop;
            case "right":
                return styles.tooltipRight;
            case "bottom":
                return styles.tooltipBottom;
            case "left":
                return styles.tooltipLeft;
            default:
                return styles.tooltipBottom;
        }
    }
    adjustTooltipPosition() {
        const rect = this.props.reference.current?.getBoundingClientRect();
        if (rect) {
            if (rect.bottom > window.innerHeight) {
                this.setState({ tooltipPosition: "top" });
            }
            else if (rect.top < 0) {
                this.setState({ tooltipPosition: "bottom" });
            }
            else if (rect.right > window.innerWidth) {
                this.setState({ tooltipPosition: "left" });
            }
            else if (rect.left < 0) {
                this.setState({ tooltipPosition: "right" });
            }
        }
    }
    render() {
        if (!this.props.reference.current)
            return null;
        const rect = this.props.reference.current.getBoundingClientRect();
        const { top, left, width, height } = rect;
        const baseStyle = {
            position: "absolute",
            zIndex: 9999,
        };
        let positionStyle = {};
        switch (this.state.tooltipPosition) {
            case "top":
                positionStyle = {
                    bottom: window.innerHeight - (rect.top + window.scrollY),
                    left: left + window.scrollX + width / 2,
                    transform: "translateX(-50%)",
                    marginBottom: "6px",
                };
                break;
            case "bottom":
                positionStyle = {
                    top: top + window.scrollY + height,
                    left: left + window.scrollX + width / 2,
                    transform: "translateX(-50%)",
                    marginTop: "6px",
                };
                break;
            case "left":
                positionStyle = {
                    top: top + window.scrollY + height / 2,
                    right: window.innerWidth - (rect.right + window.scrollX),
                    transform: "translateY(-50%)",
                    marginRight: "6px",
                };
                break;
            case "right":
                positionStyle = {
                    top: top + window.scrollY + height / 2,
                    left: left + window.scrollX + width,
                    transform: "translateY(-50%)",
                    marginLeft: "6px",
                };
                break;
        }
        if (this.props.addLeftPx && positionStyle.left) {
            positionStyle.left =
                positionStyle.left + this.props.addLeftPx;
        }
        const style = {
            ...baseStyle,
            ...positionStyle,
        };
        return ReactDOM.createPortal(React.createElement("span", { className: `${styles.tooltip} ${this.getTooltipPositionClass()} ${this.props.className || ""}`, style: style },
            React.createElement("div", { className: styles.content, style: this.props.style },
                React.createElement("p", { className: styles.text }, this.props.children)),
            React.createElement("div", { className: styles.arrow })), document.body);
    }
}
